import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../services/api.service';
import {Store} from '../store';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PagesService {
    env = environment;

    constructor(
        private http: HttpClient,
        private apiService: ApiService,
        private store: Store,
        private toastrService: ToastrService,
    ) {
    }

    getPages(params) {
        const dataToSend = {
            user: this.store.selectForLocal('user'),
            params
        };
        return this.http.post(this.env.apiPath + 'cms/admin/pages/search', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data.data;
        }));
    }

    getPage(route) {
        return this.http.get(this.env.apiPath + 'cms/admin/pages/' + route, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    createPage(page) {
        const dataToSend = {
            user: this.store.selectForLocal('user'),
            page
        };
        return this.http.post(this.env.apiPath + 'cms/admin/pages', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    updatePage(page) {
        const dataToSend = {
            user: this.store.selectForLocal('user'),
            page
        };
        return this.http.put(this.env.apiPath + 'cms/admin/pages', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    delete(page) {
        const dataToSend = {
            user: this.store.selectForLocal('user'),
            page
        };
        return this.http.post(this.env.apiPath + 'cms/admin/pages/delete', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

}
